import React from 'react';
import ReactDOM from 'react-dom';
import jumpTo from './Game'
let hello="Please Enter Your Name:";
let val;
class NameForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      p1: '',
      p2: '',
      p3:'',
    };
  }

  myChangeHandler = (event) => {
    var nam = event.target.name;
    var val = event.target.value;
    this.setState({[nam]: val});
    }
  render() {
    localStorage.clear();
    localStorage.setItem("val1",this.state.p1);
    localStorage.setItem("val2",this.state.p2);
    localStorage.setItem("val3",this.state.p3);
    if(this.state.p2!='' && this.state.p1!='')
    {
      hello="Hello "+this.state.p1+" and "+this.state.p2+"!";
    }
    else if(this.state.p3!='')
    {
      hello="Hello "+this.state.p3+"!";
    }
    return (
      <form className="nameform">
      <script src="http://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js" type="text/javascript"></script>

<script type="text/javascript" src="js/script.js"></script>
      <div>
  <label>Two Player </label>
  <label class="switch">
  <input type="checkbox" action=""id="mode" onClick={()=>{
    var x = document.getElementById("two");
    var y = document.getElementById("single");
    x.style.display=="none"?x.style.display="block":x.style.display="none";
    y.style.display=="block"?y.style.display="none":y.style.display="block";

    // if(x.style.display=="none")
    // alert("You can't beat the AI bot- Slayer!")
  }}  />

  <span class="slider round"></span>
</label><label> Single Player</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <label className="lab">Dark Mode: </label>
  <label class="switch">
  <input type="checkbox" onClick={()=>{document.body.classList.toggle("dark-mode");document.getElementById("nav").classList.toggle("nav-dark");}}  />
  <span class="slider round"></span>
</label>
  </div>
  <hr/>
        <strong className="high">{hello}</strong>
        <br/>
        <br/>

  <div id="two" >
      <label>Player X: </label>
      <input
        type='text'
        name='p1'
        onChange={this.myChangeHandler}
      />
      &nbsp;&nbsp;&nbsp;
      <label>Player O: </label>
      <input
        type='text'
        name='p2'
        onChange={this.myChangeHandler}
      />
    </div>
    <div id="single">
    <label>Player: </label>
    <input
      type='text'
      name='p3'
      onChange={this.myChangeHandler}
    /> v/s Slayer
    </div>
      </form>
    );


    }

}
export default NameForm
ReactDOM.render(<NameForm />, document.getElementById('root'));
